import * as d3 from 'd3';

export interface IndexedTsPoint {
  index: number;
  value: number;
  date: Date;
}

type SelectionOrTransition<
  GElement extends d3.BaseType,
  Datum,
  PElement extends d3.BaseType,
  PDatum,
  AElement extends d3.BaseType
> =
  | d3.Selection<GElement, Datum, PElement, PDatum>
  | d3.Transition<GElement, Datum, AElement, unknown>;

export const maybeAnimated = <
  GElement extends d3.BaseType,
  Datum,
  PElement extends d3.BaseType,
  PDatum,
  AElement extends d3.BaseType
>(
  selection: d3.Selection<GElement, Datum, PElement, PDatum>,
  transition?: d3.Transition<AElement, unknown, null, undefined>
) => {
  type SelOrTransition = SelectionOrTransition<
    GElement,
    Datum,
    PElement,
    PDatum,
    AElement
  >;

  return (fn: (selection: SelOrTransition) => void) => {
    let transitionOrSelection: SelOrTransition = selection;
    try {
      if (transition) {
        transitionOrSelection = transition.selectAll(() => selection.nodes());
      }
    } catch (e) {}

    try {
      transitionOrSelection?.call(fn);
    } catch (e) {
      selection.call(fn);
    }
  };
};
